import { render } from "./UnifiedSidebar.vue?vue&type=template&id=078a8995&scoped=true"
import script from "./UnifiedSidebar.vue?vue&type=script&lang=js"
export * from "./UnifiedSidebar.vue?vue&type=script&lang=js"

import "./UnifiedSidebar.vue?vue&type=style&index=0&id=078a8995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078a8995"]])

export default __exports__